import React, { VFC } from 'react';

import { flatMap } from 'lodash';

import audioSvgPath from './svgs/Audio.svg';
import cssSvgPath from './svgs/CSS.svg';
import docSvgPath from './svgs/Doc.svg';
import emailSvgPath from './svgs/Email.svg';
import genericSvgPath from './svgs/Generic.svg';
import imageSvgPath from './svgs/Image.svg';
import linkSvgPath from './svgs/Link.svg';
import presentationSvgPath from './svgs/Presentation.svg';
import spreadsheetSvgPath from './svgs/Spreadsheet.svg';
import TranslationPath from './svgs/Translation.svg';
import videoSvgPath from './svgs/Video.svg';
import zipSvgPath from './svgs/Zip.svg';

// Shorter to write and easier to maintain a map from svg to icon name
const pathToNames = [
  [audioSvgPath, 'aiff asnd au audio mp3 wav wma'],
  [cssSvgPath, 'css'],
  [docSvgPath, 'doc docx odt'],
  [emailSvgPath, 'eml'],
  [imageSvgPath, 'ai bmp eps gif img indd jpg odg png psd svg tiff xbm'],
  [presentationSvgPath, 'key odp ppt pptx'],
  [spreadsheetSvgPath, 'numbers ods xls xlsx'],
  [
    videoSvgPath,
    'aep asf avi avx fla flv fxp m4v mov movie mp4 mpeg2 ogv ppj swf video webm wmv',
  ],
  [zipSvgPath, 'zip'],
  [linkSvgPath, 'link'],
  [TranslationPath, 'Translation'],
];

// Flipping the map - name to svg path
const nameToPath = new Map(
  flatMap(pathToNames, ([path, names]) =>
    names.split(' ').map((name: string) => [name, path]),
  ),
);

const Icon: VFC<{ name: string }> = ({ name }) => (
  <img src={nameToPath.get(name) || genericSvgPath} />
);

export default Icon;
